// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/automations/v1/automations.proto" (package "c1.api.automations.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AutomationService } from "./automations";
import type { ExecuteAutomationResponse } from "./automations";
import type { ExecuteAutomationRequest } from "./automations";
import type { UpdateAutomationResponse } from "./automations";
import type { UpdateAutomationRequest } from "./automations";
import type { DeleteAutomationResponse } from "./automations";
import type { DeleteAutomationRequest } from "./automations";
import type { ListAutomationsResponse } from "./automations";
import type { ListAutomationsRequest } from "./automations";
import type { CreateAutomationResponse } from "./automations";
import type { CreateAutomationRequest } from "./automations";
import type { GetAutomationResponse } from "./automations";
import type { GetAutomationRequest } from "./automations";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AutomationSearchService } from "./automations";
import type { SearchAutomationTemplateVersionsResponse } from "./automations";
import type { SearchAutomationTemplateVersionsRequest } from "./automations";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { SearchAutomationsResponse } from "./automations";
import type { SearchAutomationsRequest } from "./automations";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.automations.v1.AutomationSearchService
 */
export interface IAutomationSearchServiceClient {
    /**
     * @generated from protobuf rpc: SearchAutomations(c1.api.automations.v1.SearchAutomationsRequest) returns (c1.api.automations.v1.SearchAutomationsResponse);
     */
    searchAutomations(input: SearchAutomationsRequest, options?: RpcOptions): UnaryCall<SearchAutomationsRequest, SearchAutomationsResponse>;
    /**
     * @generated from protobuf rpc: SearchAutomationTemplateVersions(c1.api.automations.v1.SearchAutomationTemplateVersionsRequest) returns (c1.api.automations.v1.SearchAutomationTemplateVersionsResponse);
     */
    searchAutomationTemplateVersions(input: SearchAutomationTemplateVersionsRequest, options?: RpcOptions): UnaryCall<SearchAutomationTemplateVersionsRequest, SearchAutomationTemplateVersionsResponse>;
}
/**
 * @generated from protobuf service c1.api.automations.v1.AutomationSearchService
 */
export class AutomationSearchServiceClient implements IAutomationSearchServiceClient, ServiceInfo {
    typeName = AutomationSearchService.typeName;
    methods = AutomationSearchService.methods;
    options = AutomationSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: SearchAutomations(c1.api.automations.v1.SearchAutomationsRequest) returns (c1.api.automations.v1.SearchAutomationsResponse);
     */
    searchAutomations(input: SearchAutomationsRequest, options?: RpcOptions): UnaryCall<SearchAutomationsRequest, SearchAutomationsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAutomationsRequest, SearchAutomationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAutomationTemplateVersions(c1.api.automations.v1.SearchAutomationTemplateVersionsRequest) returns (c1.api.automations.v1.SearchAutomationTemplateVersionsResponse);
     */
    searchAutomationTemplateVersions(input: SearchAutomationTemplateVersionsRequest, options?: RpcOptions): UnaryCall<SearchAutomationTemplateVersionsRequest, SearchAutomationTemplateVersionsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAutomationTemplateVersionsRequest, SearchAutomationTemplateVersionsResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.automations.v1.AutomationService
 */
export interface IAutomationServiceClient {
    /**
     * @generated from protobuf rpc: GetAutomation(c1.api.automations.v1.GetAutomationRequest) returns (c1.api.automations.v1.GetAutomationResponse);
     */
    getAutomation(input: GetAutomationRequest, options?: RpcOptions): UnaryCall<GetAutomationRequest, GetAutomationResponse>;
    /**
     * @generated from protobuf rpc: CreateAutomation(c1.api.automations.v1.CreateAutomationRequest) returns (c1.api.automations.v1.CreateAutomationResponse);
     */
    createAutomation(input: CreateAutomationRequest, options?: RpcOptions): UnaryCall<CreateAutomationRequest, CreateAutomationResponse>;
    /**
     * @generated from protobuf rpc: ListAutomations(c1.api.automations.v1.ListAutomationsRequest) returns (c1.api.automations.v1.ListAutomationsResponse);
     */
    listAutomations(input: ListAutomationsRequest, options?: RpcOptions): UnaryCall<ListAutomationsRequest, ListAutomationsResponse>;
    /**
     * @generated from protobuf rpc: DeleteAutomation(c1.api.automations.v1.DeleteAutomationRequest) returns (c1.api.automations.v1.DeleteAutomationResponse);
     */
    deleteAutomation(input: DeleteAutomationRequest, options?: RpcOptions): UnaryCall<DeleteAutomationRequest, DeleteAutomationResponse>;
    /**
     * @generated from protobuf rpc: UpdateAutomation(c1.api.automations.v1.UpdateAutomationRequest) returns (c1.api.automations.v1.UpdateAutomationResponse);
     */
    updateAutomation(input: UpdateAutomationRequest, options?: RpcOptions): UnaryCall<UpdateAutomationRequest, UpdateAutomationResponse>;
    /**
     * @generated from protobuf rpc: ExecuteAutomation(c1.api.automations.v1.ExecuteAutomationRequest) returns (c1.api.automations.v1.ExecuteAutomationResponse);
     */
    executeAutomation(input: ExecuteAutomationRequest, options?: RpcOptions): UnaryCall<ExecuteAutomationRequest, ExecuteAutomationResponse>;
}
/**
 * @generated from protobuf service c1.api.automations.v1.AutomationService
 */
export class AutomationServiceClient implements IAutomationServiceClient, ServiceInfo {
    typeName = AutomationService.typeName;
    methods = AutomationService.methods;
    options = AutomationService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAutomation(c1.api.automations.v1.GetAutomationRequest) returns (c1.api.automations.v1.GetAutomationResponse);
     */
    getAutomation(input: GetAutomationRequest, options?: RpcOptions): UnaryCall<GetAutomationRequest, GetAutomationResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAutomationRequest, GetAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateAutomation(c1.api.automations.v1.CreateAutomationRequest) returns (c1.api.automations.v1.CreateAutomationResponse);
     */
    createAutomation(input: CreateAutomationRequest, options?: RpcOptions): UnaryCall<CreateAutomationRequest, CreateAutomationResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAutomationRequest, CreateAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAutomations(c1.api.automations.v1.ListAutomationsRequest) returns (c1.api.automations.v1.ListAutomationsResponse);
     */
    listAutomations(input: ListAutomationsRequest, options?: RpcOptions): UnaryCall<ListAutomationsRequest, ListAutomationsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAutomationsRequest, ListAutomationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteAutomation(c1.api.automations.v1.DeleteAutomationRequest) returns (c1.api.automations.v1.DeleteAutomationResponse);
     */
    deleteAutomation(input: DeleteAutomationRequest, options?: RpcOptions): UnaryCall<DeleteAutomationRequest, DeleteAutomationResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAutomationRequest, DeleteAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateAutomation(c1.api.automations.v1.UpdateAutomationRequest) returns (c1.api.automations.v1.UpdateAutomationResponse);
     */
    updateAutomation(input: UpdateAutomationRequest, options?: RpcOptions): UnaryCall<UpdateAutomationRequest, UpdateAutomationResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateAutomationRequest, UpdateAutomationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ExecuteAutomation(c1.api.automations.v1.ExecuteAutomationRequest) returns (c1.api.automations.v1.ExecuteAutomationResponse);
     */
    executeAutomation(input: ExecuteAutomationRequest, options?: RpcOptions): UnaryCall<ExecuteAutomationRequest, ExecuteAutomationResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ExecuteAutomationRequest, ExecuteAutomationResponse>("unary", this._transport, method, opt, input);
    }
}
